import { $ABTest } from '@lemon8/web-app-shared/atom';
import { Atom, atom } from 'jotai';
import _get from 'lodash/get';

/**
 * v0: control group
 * v1: add Today's date to the page description
 * v2: add current Monday's date to the page description
 */
export const $SEOKepAddDate: Atom<string> = atom((get) => {
  const { parameters } = get($ABTest);
  if (__BUILD_TYPE__ === 'local_dev') {
    return 'v1';
  }
  return _get(parameters, ['seo_web', 'lemon8.kep_add_date'], 'v1');
});
